<template>
  <div class="tit">
    <h3>{{titlemsg}}</h3>
    <!-- <img src="/static/images/re.png" alt=""> -->
  </div>

</template>

<script>
export default {
    props:['titlemsg']
}

</script>

<style>
  .tit{
    width: 100%;
    /* height: 0.4rem;
    line-height: 0.4rem; */
    /* background-color: #0e4498; */
	/* background: rgba(14, 68 ,152,.2); */
    font-size: 0.14rem;
    color: #fff;
    border-radius: 0.04rem;
    position: relative;
    /* margin-top: 0.12rem; */
    height: 4vh;
    line-height: 4vh;
    margin-top: .6vh;
    margin-bottom: .4vh;
  }
  .tit>h3{
    font-size: 0.23rem;
    font-weight: 400;
    text-align: center;
  }
  .tit>img{
    width: 0.2rem;
    position: absolute;
    right:0.15rem;
    top: 0.1rem;
  }
  .mtt{
    margin-top: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/title.vue